import { Menu } from 'antd';
import type { MenuProps } from 'antd';
import React from 'react';

import useAnalytics from 'config/analytics';
import type { AnalyticsEvent } from 'config/analytics';
import type { MayBe } from 'modules/global/typing/common/common';

type MenuItem = NonNullable<MenuProps['items']>[number] & {
  analytics?: AnalyticsEvent;
  children?: MenuItem[];
};

/** antd reports `keyPath` leaf-first, hence the walk from the end. */
const getItem = (items: MenuItem[], keyPath: string[]): MayBe<MenuItem> => {
  const restKeyPath = keyPath.toSpliced(-1);
  const currentKey = [...keyPath].pop();
  const item = items.find(entry => entry && 'key' in entry && entry.key === currentKey);

  if (restKeyPath.length === 0) {
    return item as MayBe<MenuItem>;
  }
  return getItem((item as MayBe<MenuItem>)?.children ?? [], restKeyPath);
};

const FBMenu: React.FC<MenuProps> = ({ children, onClick: onClickProp, ...rest }) => {
  const { onClick } = useAnalytics();

  const handleOnClick: NonNullable<MenuProps['onClick']> = event => {
    const item = getItem((rest.items ?? []) as MenuItem[], event.keyPath);
    onClick(item?.analytics, onClickProp)(event);
  };

  return (
    <Menu {...rest} onClick={handleOnClick}>
      {children}
    </Menu>
  );
};

export default FBMenu;
